<template>
<div class="wrap">
   <div class="title">城房案场-销售经理权限说明</div> 
   <div class="content_title">在您使用城房案场-销售经理时，可能需要开启以下权限，以获得相关服务；如果您不是使用这些功能，可以不开启以下权限，不开启权限不会影响您基础功能的使用，我们将依法保护您的个人信息安全。</div>
   <div class="content_title">相册</div> 
   <div class="content">开启相册权限，包括读取存储卡中的内容，方便用户使用相册内照片上传用户头像。</div> 
   <div class="content_title">使用相机</div> 
   <div class="content">开启相机使用权限，包括拍摄图片和录制视频，方便使用拍摄用户头像、上传文件等图片信息。</div> 
  </div>
</template>
<script>
export default {
    name: 'Permission',
    data(){
        return{
            
        }
    }
}
</script>

<style lang="less" scoped>
  @import url(../assets/styles/common.css);
</style>